const store = (state = null, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SET_STORE':
      return payload;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default store;
